/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";
import { NavLink, withRouter } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
// import ContentCopy from "@material-ui/icons/ContentCopy";
import Store from "@material-ui/icons/Store";
// import InfoOutline from "@material-ui/icons/InfoOutline";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Refresh from "@material-ui/icons/Refresh";
import Edit from "@material-ui/icons/Edit";

import Language from "@material-ui/icons/Language";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Danger from "components/Typography/Danger.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CardText from "components/Card/CardText";

import { ROLES_STRING } from 'constants/user';

import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions';

import {
  dangerColor,
  infoColor,
  grayColor,
} from "assets/jss/material-dashboard-pro-react.jsx";

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart
} from "variables/charts";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import enbrainImage from "assets/img/enbrain_white.png";

import { ACTIVITY_LEVEL_LABELS } from "constants/form";
import { getAllUsersCount, getAllOrgsCount } from "db";
import { ORG_STATUS } from "constants/org";


class DashboardForSuperAdmin extends React.Component {
  state = {
    value: 0
  };
  handleChange = (event, value) => {
    this.setState({ value });
  };
  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  async componentDidMount() {

    if (!this.unsubscribeStatistics) {
      this.unsubscribeStatistics = this.props.watchingStatistics('global');
      this.props.getOrgsAction();
    }
  }


  componentWillUnmount() {
    if (this.unsubscribeStatistics) {
      this.unsubscribeStatistics();
    }
  }

  render() {
    const { classes, currentRole, orgs, statistics } = this.props;
    console.log('statistics = ', statistics);
    return (
      <div>
        {/* {currentRole ? ROLES_STRING[currentRole.role - 1] : 'Loading...'} */}
        <GridContainer>
          <GridItem xs={12}>
            <GridContainer>
              <div style={{
                backgroundColor: dangerColor[0],
                borderRadius: 10,
                width: 20,
                height: 20,
                marginRight: "8px"
              }}></div><span>{'엔브레인 플랫폼'}</span>
            </GridContainer>
          </GridItem>

          <GridItem xs={12} sm={12} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="danger" stats text>
                <CardText color="danger">
                  <div className={classes.titleLogoContainer}>
                    <img src={enbrainImage} className={classes.titleLogo} />
                    <h3 className={classes.cardTitle}>
                      엔브레인 플랫폼 종합기관수
                    </h3>
                  </div>
                </CardText>
              </CardHeader>
              <CardBody>
                <GridContainer align="center">
                  <GridItem xs={12}>
                    <div style={{
                      color: dangerColor[0],
                      fontSize: '2.5em',
                      fontWeight: '400',
                    }}>{statistics.orgsCount ? statistics.orgsCount[0].count : 0}</div>
                    <div style={{
                      color: grayColor[0],
                      marginTop: 10,
                      fontSize: '0.9em',
                    }}>기관 종합 통계</div>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="danger" stats text>
                <CardText color="danger">
                  <div className={classes.titleLogoContainer}>
                    <img src={enbrainImage} className={classes.titleLogo} />
                    <h3 className={classes.cardTitle}>
                      엔브레인플랫폼 회원수
                    </h3>
                  </div>
                </CardText>
              </CardHeader>
              <CardBody>
                <GridContainer align="center">
                  <GridItem xs={12}>
                    <div style={{
                      color: dangerColor[0],
                      fontSize: '2.5em',
                      fontWeight: '400',
                    }}>{statistics.usersCount ? statistics.usersCount[0].count : 0}</div>
                    <div style={{
                      color: grayColor[0],
                      marginTop: 10,
                      fontSize: '0.9em',
                    }}>기관회윈 및 일반회원 통계</div>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} className={classes.grid}>
            <Card>
              <CardBody style={{ textAlign: "center" }}>
                <h3>주식회사 캐어유</h3>
                <GridContainer>
                  {
                    orgs && orgs.filter(org => org.get('status') >= ORG_STATUS.ASSOCIATE_MEMBER).map((org, idx) => <GridItem key={idx} xs={12} sm={12} md={4} lg={4}>
                      <Button
                        color={'primary'}
                        fullWidth
                        onClick={() => {
                          console.log('org', org);
                          this.props.selectCurrentOrgAction(org);
                          this.props.history.push(`/admin/dashboardForOrg`, { org_id: org.id });
                        }}
                      >
                        {org.data().기관명}
                      </Button>
                    </GridItem>)
                  }
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

DashboardForSuperAdmin.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
  return {
    members: state.member.members,
    orgs: state.org.orgs,
    currentOrg: state.org.currentOrg,
    currentRole: state.auth.currentRole,
    statistics: state.statistics,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}


export default compose(
  withStyles(dashboardStyle),
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(DashboardForSuperAdmin);